import { Alerts, Block, Overview, Website } from "@similarweb/icons";
import { Badge } from "@similarweb/ui-components";

import { createLegacyCategoryIcon } from "app/pages/sales-intelligence/common-components/filters-panel/utils/icons";
import type { IFiltersConfigCategoryItem } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/category";
import advancedFilteringI18nKeys from "app/pages/sales-intelligence/modules/advanced-search-filtering/utils/i18n";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";

import { SignalsCategoryHeaderAction } from "../containers/CategoryHeaderAction/SignalsCategoryHeaderAction";
import { CrmCategoryEmptyState } from "../containers/CrmCategoryEmptyState/CrmCategoryEmptyState";
import { type LeadsFilterCategory, leadsFilterCategoryMap } from "../types/leadsFilterCategory";

const InternalBadge = () => (salesSettingsHelper.isCrmCustomFiltersEnabled ? <Badge type="internal" /> : null);

export const leadsCategories = {
    crm: {
        id: leadsFilterCategoryMap.crm,
        order: 10,
        icon: createLegacyCategoryIcon("crm"),
        titleKey: advancedFilteringI18nKeys.category(leadsFilterCategoryMap.crm),
        emptyContent: CrmCategoryEmptyState,
        badge: InternalBadge,
    },
    signals: {
        id: leadsFilterCategoryMap.signals,
        order: 20,
        icon: Alerts,
        titleKey: advancedFilteringI18nKeys.category(leadsFilterCategoryMap.signals),
        headerAction: SignalsCategoryHeaderAction,
        viewMoreTooltipKey: advancedFilteringI18nKeys.categoryViewMoreTooltip(leadsFilterCategoryMap.signals),
    },
    company: {
        id: leadsFilterCategoryMap.company,
        order: 30,
        icon: createLegacyCategoryIcon("sidebar3-company-analysis"),
        titleKey: advancedFilteringI18nKeys.category(leadsFilterCategoryMap.company),
    },
    website: {
        id: leadsFilterCategoryMap.website,
        order: 40,
        icon: Website,
        titleKey: advancedFilteringI18nKeys.category(leadsFilterCategoryMap.website),
    },
    trafficAndEngagement: {
        id: leadsFilterCategoryMap.trafficAndEngagement,
        order: 50,
        icon: Overview,
        titleKey: advancedFilteringI18nKeys.category(leadsFilterCategoryMap.trafficAndEngagement),
    },
    advertiserActivity: {
        id: leadsFilterCategoryMap.advertiserActivity,
        order: 60,
        icon: createLegacyCategoryIcon("ad-research"),
        titleKey: advancedFilteringI18nKeys.category(leadsFilterCategoryMap.advertiserActivity),
        get isLocked() {
            return !salesSettingsHelper.isSIAdIntelligenceEnabled;
        },
        withIndicator: true,
    },
    exclude: {
        id: leadsFilterCategoryMap.exclude,
        order: 100,
        icon: Block,
        titleKey: advancedFilteringI18nKeys.category(leadsFilterCategoryMap.exclude),
    },
} as const satisfies Record<LeadsFilterCategory, IFiltersConfigCategoryItem>;
